import React from "react";
import LegalLayout from "../../components/legal/LegalLayout";
import LegalTableOfContents from "../../components/legal/LegalTableOfContents";
import {
  termsOfServiceSections,
  LEGAL_LAST_UPDATED,
} from "../../data/legalContent";
import LegalSectionContent from "./LegalSectionContent";

export default function TermsOfServicePage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated={LEGAL_LAST_UPDATED}>
      <LegalTableOfContents sections={termsOfServiceSections} />
      {termsOfServiceSections.map((section) => (
        <LegalSectionContent key={section.id} section={section} />
      ))}
    </LegalLayout>
  );
}
